export default function bemit (base, modifiers=[])
{
	return [base].concat(modifiers.filter(str => str)).join(' ' + base + '--');
}